import React from "react";
import { Provider } from "react-redux";
import { Route, Switch, BrowserRouter, Redirect } from "react-router-dom";
import AuthLayout from "./layouts/auth/index";
import PrivateRouteWrapper from "./routes/private/PrivateRouteWrapper";
import PrivateRoutes from "./routes/private/PrivateRoutes";
import { createBrowserHistory } from "history";
import store from "./redux/store";
import {
  QueryClient,
  QueryClientProvider,
} from "react-query"

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1
    },
  },
})

export const history = createBrowserHistory();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <BrowserRouter>
          <Switch>
            <Route path="/auth" render={() => <AuthLayout  />} />
            <PrivateRouteWrapper >
              <PrivateRoutes />
            </PrivateRouteWrapper>
            <Redirect from="*" to="/auth/login" />
          </Switch>
        </BrowserRouter>
      </Provider>
    </QueryClientProvider>
  );
}

export default App;
